export const menuListData = [
  'dashboard', 'salesboard', 'users', 'leads', 'qualified', 'disqualified', 'closedWon', 'closedLoss', 'contacts',
  'companies', 'opportunities', 'quotations', 'tasks', 'meetings', 'activities', 'reports', 'administration'
];

export const menuToRoutePath = {
  "MENU-001": "/dashboard",
  "MENU-002": "/salesboard", 
  "MENU-003": "/users",
  "MENU-004": "/lead",
  "MENU-005": "/qualified",
  "MENU-006": "/disqualified",
  "MENU-007": "/closedWon",
  "MENU-008": "/closedLoss",
  "MENU-009": "/contacts",
  "MENU-010": "/companies",
  "MENU-011": "/opportunities",
  "MENU-012": "/quotations",
  "MENU-013": "/tasks",
  "MENU-014": "/meetings",
  "MENU-015": "/activities",
  "MENU-016": "/reports",
  "MENU-017": "/administration",
};